import React, { useState, useEffect } from "react";
import ContactMe from "../components/ContactMe";
import FAQs from "../components/faqs/FAQs";
import Contact from "../components/contact/Contact";

const ContactPage = () => {
  return (
    <div style={{padding:"9rem 0",backgroundColor:"var(--green)"}}>
     <ContactMe/>
     <FAQs/>
     <Contact/>

    </div>
  );
};

export default ContactPage;
